module.exports = __webpack_public_path__ + "static/worldmap@2x-abf02dbf16f0764d320db155d7e96ac3.png";